export const trackPackagePurchase = ({ email, orderInfo, orderNumber, orderTotal }) => {
  if (window.letterpress) {
    const {
      nameOnCard: name,
      billingAddress: street,
      billingZip: zip,
      billingCity: city,
      billingState: state,
      billingCountry: country
    } = orderInfo;

    // Report event only if in prod
    if (process.env.REACT_APP_ENV === 'prod') {
      window.letterpress(
        'addTrans',
        orderNumber, // order ID
        'Modsy', // affiliation or store name
        orderTotal,
        '0', // tax amount
        '0', // shipping amount
        city,
        state,
        country,
        'USD', // currency
        [{
          schema: 'iglu:com.getletterpress/address/jsonschema/1-0-0',
          data: {
            name,
            street,
            zip,
            city,
            state,
            country,
            email
          }
        }]
      );
      window.letterpress('trackTrans');
    } else { // if in dev or staging don't report the event to postie, but console
      console.log('Sending design package purchase data to Postie: ', {
        name,
        street,
        zip,
        city,
        state,
        country,
        email
      });
    }
  }
};

export const trackMerchPurchase = ({ shippingInfo, displayedInfo, orderNumber }) => {
  if (window.letterpress) {
    const {
      addressName: name,
      streetAddress: street,
      zip,
      city,
      state,
      country
    } = shippingInfo;

    const {
      displayedTotal: total,
      displayedTax: tax,
      displayedShipping: shipping
    } = displayedInfo;

    // Report event only if in prod
    if (process.env.REACT_APP_ENV === 'prod') {
      window.letterpress(
        'addTrans',
        orderNumber, // order ID
        'Modsy', // affiliation or store name
        total,
        tax,
        shipping,
        city,
        state,
        country,
        'USD', // currency
        [{
          schema: 'iglu:com.getletterpress/address/jsonschema/1-0-0',
          data: {
            name,
            street,
            zip,
            city,
            state,
            country
          }
        }]
      );
      window.letterpress('trackTrans');
    } else { // if in dev or staging don't report the event to postie, but console
      console.log('Sending merch purchase data to Postie: ', {
        name,
        street,
        zip,
        city,
        state,
        country,
        total
      });
    }
  }
};

export const trackEmailRegister = (email) => {
  if (process.env.REACT_APP_ENV === 'prod') {
    window.letterpress('trackUnstructEvent', {
      schema: 'iglu:com.getletterpress/email/jsonschema/1-0-0',
      data: {email}
    });
  } else {
    console.log('Sending email register to Postie: ', {email});
  }
};
